// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2ysXF","fullScreen":"style_fullScreen__1X2dg","hidden":"style_hidden__3NKQ3"};